import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/Button.tsx'
import { IconArrowLeft, IconUsers } from '@tabler/icons-react'
import { HeyDrive } from '@/models/drive.ts'

interface Props {
  drive: HeyDrive
  className?: string
}

export default function DriveCrossLinkButtons({ drive, className }: Props) {
  const navigate = useNavigate()

  if (!drive.child_drive && !drive.parent_drive) return null

  function goTo(driveId: string) {
    navigate(`/d/${driveId}`)
    window.scrollTo({ top: 0, behavior: 'auto' })
  }

  return (
    <div className={`flex flex-col items-stretch w-fit mx-auto gap-2 my-4 ${className ?? ''}`}>
      {drive.child_drive && (
        <Button variant="outline" size="sm" onClick={() => goTo(drive.child_drive!)}>
          <IconUsers size={16} />
          Zur Gästebilder-Galerie
        </Button>
      )}
      {drive.parent_drive && (
        <Button variant="outline" size="sm" onClick={() => goTo(drive.parent_drive!)}>
          <IconArrowLeft size={16} />
          Zurück zur Hauptgalerie
        </Button>
      )}
    </div>
  )
}
